import { useCallback, useRef } from "react";
import { debugLog } from "@/utils/debugLog";

export const useClock = () => {
  const abruptPauseTimerRef = useRef(null);
  const startTimeRef = useRef(0);
  const isPausedRef = useRef(false);
  const doneChunkRecievedRef = useRef(false);

  // Stable identities: these land in effect deps, and re-registering an event
  // subscription moves it to the tail of its listener array.
  const getDelta = useCallback(() => {
    return Date.now() - startTimeRef.current;
  }, []);

  const resetClock = useCallback(() => {
    debugLog("resetClock");
    startTimeRef.current = Date.now();
  }, []);

  return {
    doneChunkRecievedRef,
    isPausedRef,
    abruptPauseTimerRef,
    startTimeRef,
    getDelta,
    resetClock,
  };
};
